// extracted by mini-css-extract-plugin
export default {"version":"AmIT_tfJnyCITc7TbaZQ"};